module.exports = __webpack_public_path__ + "img/default-avatar.d685212c.png";